import React from 'react';
import Head from 'next/head';
import getConfig from 'next/config';

import {SiteArea} from '~/src/utilities/constants/navigation';
import {Tenant} from '~/src/utilities/constants/tenant';

import initPolyglot from '~/src/utilities/libs/polyglot';

import i18n from './ogTag.i18n.json';
const getTranslation = initPolyglot(i18n);

const {publicRuntimeConfig: config} = getConfig();

const getOgImage = (imageObj) => {
    return [
        <meta key="og:image" property="og:image" content={imageObj.src} />,
        <meta key="og:image:width" property="og:image:width" content={imageObj.maxWidth} />,
        <meta key="og:image:height" property="og:image:height" content={imageObj.maxHeight} />
    ];
};

const createOgMetaTagsNewsArticle = (config, meta, canonicalUrl, facebookTeaser) => {
    const ogArticlePublisher = `https://www.facebook.com/${
        config.tenantId === Tenant.LEMATIN ? 'lematin.ch' : config.tenantId === Tenant.TWENTY_MIN_FR ? '20minutesonline' : '20min'
    }`;

    const ogLocale = config.tenantId === Tenant.LEMATIN || config.tenantId === Tenant.TWENTY_MIN_FR ? 'fr_FR' : 'de_DE';

    let ogMetaTagsNewsArticle = [
        <meta key="og:type" property="og:type" content="article" />,
        <meta key="og:description" property="og:description" content={facebookTeaser.description} />,
        <meta key="og:url" property="og:url" content={canonicalUrl} />,
        <meta key="og:title" property="og:title" content={getTranslation(facebookTeaser.titleHeader ? 'titleWithTitleHeader' : 'title', facebookTeaser)} />,
        <meta key="og:locale" property="og:locale" content={ogLocale} />,
        <meta key="og:article:publisher" property="article:publisher" content={ogArticlePublisher} />,
        <meta key="og:site_name" property="og:site_name" content={config.tenantName} />,
        <meta key="og:updated_time" property="og:updated_time" content={meta.updated} />,
        <meta key="article:published_time" property="article:published_time" content={meta.published} />,
        <meta key="article:modified_time" property="article:modified_time" content={meta.updated} />
    ];

    const imgVariant = facebookTeaser.images && ['fix1200x675px', 'fix1200x900px', 'fix1200x1200px', '1200px', 'big'].find((img) => facebookTeaser.images[img]);

    if (imgVariant) {
        const image = getOgImage(facebookTeaser.images[imgVariant]);
        ogMetaTagsNewsArticle.push(...image);
    }

    return ogMetaTagsNewsArticle;
};

const OgTag = ({siteArea, facebookTeaser, canonicalUrl, meta}) => {
    const ogMetaTags = [
        <meta key="ogTitle" property="og:title" content={facebookTeaser.title} />,
        <meta key="ogDescription" property="og:description" content={facebookTeaser.description} />,
        <meta key="ogType" property="og:type" content="article" />,
        <meta key="ogUrl" property="og:url" content={canonicalUrl} />
    ];

    if (facebookTeaser?.images?.big) {
        ogMetaTags.push(<meta key="ogImage" property="og:image" content={facebookTeaser.images.big.src} />);
    }

    return (
        <Head>
            {siteArea !== SiteArea.NEWS && siteArea !== SiteArea.LIFESTYLE && ogMetaTags}
            {(siteArea === SiteArea.NEWS || siteArea === SiteArea.LIFESTYLE) && createOgMetaTagsNewsArticle(config, meta, canonicalUrl, facebookTeaser)}
        </Head>
    );
};

export default OgTag;
